import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RESPONSE_TRACKING } from '@constants/tramite-pension-constant';
import { IEstadoTramitePensionResponse } from '@interfaces/estado-tramite-pension.response.interface';
import { StorageService } from '@services/storage/storage.service';
import { Util } from '@shared/common/utils/util';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EstadoTramitePensionService {

  private estadoTramitePensionPromise: Promise<IEstadoTramitePensionResponse> | null = null;
  private lastToken: string | null = null;

  constructor(private readonly http: HttpClient, private readonly util: Util) { }

  public getEstadoTramitePension(token: string): Promise<IEstadoTramitePensionResponse> {
    if (this.estadoTramitePensionPromise && this.lastToken === token) {
      return this.estadoTramitePensionPromise;
    }
    const url = `${environment.BASE_BACKEND}/tramite-pension/estado-tracking`;
    const headers = this.util.getHeaders(token);
    const body = {};

    this.lastToken = token;

    this.estadoTramitePensionPromise = firstValueFrom(this.http.post<IEstadoTramitePensionResponse>(url, body, { headers }))
      .finally(() => {
        // Limpiar la promesa después de que se complete (éxito o error)
        this.estadoTramitePensionPromise = null;
        this.lastToken = null;
      });

    return this.estadoTramitePensionPromise;
  }

  public async getCacheEstadoTramitePensionVejezNormal(
    storageService: StorageService,
    token: string,
  ): Promise<IEstadoTramitePensionResponse> {
    const estadoTramitePensionResponseCache = await storageService.get(RESPONSE_TRACKING);
    if (estadoTramitePensionResponseCache?.data) {
      return estadoTramitePensionResponseCache;
    }

    const response = await this.getEstadoTramitePension(token);
    await storageService.set(RESPONSE_TRACKING, response);

    return response;
  }
}
